import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { CommonHttpService } from './http.service';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ZipCodeRangeModel } from '../models/zip-code-range.model';

@Injectable()
export class FreightCalculatorService {
    private calculatingSource: Subject<null> = new Subject();
    private calculatedSource: Subject<Array<ZipCodeRangeModel>> = new Subject();
    public calculating$ = this.calculatingSource.asObservable();
    public calculated$ = this.calculatedSource.asObservable();

    constructor(
        protected http: CommonHttpService
    ) {}

    /**
     * Call API to load all freights to this zip code.
     * */
    public calculate(zipCode: string): Observable<Array<ZipCodeRangeModel>> {
        this.calculatingSource.next();
        return new Observable(observable => {
            this.http
                .get('/ecommerce/zip-code-ranges?zip_code=' + zipCode.replace(/\D/g, ''))
                .subscribe((response: Response) => {
                    const options = response.json().data;
                    this.calculatedSource.next(options);

                    observable.next(options);
                    observable.complete();
                });
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/shared/services/freight-calculator.service.ts